module.exports = __webpack_public_path__ + "static/media/cheque.3b1c24f2.jpg";